/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFieldArray, useForm, Controller } from "react-hook-form";
import "../../registration/registration.css";
import {
  Box,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Button
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Link } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ConsentDialog from "../../../components/common/ConsentDialog";
import AccordionDetails from "@mui/material/AccordionDetails";
import { apiEndPoints } from "../../../ApiServices/config";
import { getApi, postApi } from "../../../ApiServices/api";
import toast from "react-hot-toast";
import { AddCircle, RemoveCircle } from "@mui/icons-material";
import PoojaBasket from "../../../components/common/Basket/PoojaBoasket/PoojaBasket";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { useSelector, useDispatch } from "react-redux";
import { updateCart } from "../../../actions";
import { logEvent } from "../../../utils/analytics";
import templeJson from "../../../config/temple.json";
//-------------------------------------------------------------------------------------------------

const localizer = momentLocalizer(moment);
const schema = yup.object().shape({
  first_name: yup.string().required("First Name is required"),
  last_name: yup.string().required("Last Name is required"),
  pooja_id: yup.string().required("Please select a service"),
  ocassion: yup.string().required("Please select an Ocassion"),
  service: yup.string(),
  nakshatram: yup.string().nullable(),
  gotram: yup.string().nullable(),
});

const defaultValues = {
  pooja_id: "",
};

const payload = {
  country_id: "611ce96de2cd656171314e2a",
  state_id: "611ceb61e2cd656171314e69",
  nakshatram_id: "611cec0ee2cd656171314edf",
  language_id: "611d063ee2cd656171314ee8",
};

//0----------------------------------------------------------------------------------------------------
function RecurringServices() {
  const [visibleRows, setVisibleRows] = useState(3);
  const [quantity, setQuantity] = useState(1);
  const [events, setEvents] = useState([]);
  const [open, setOpen] = useState(false);
  const [monthlyServiceData, setMonthlyServiceData] = useState();
  const [weeklyServiceData, setWeeklyServiceData] = useState();
  const [dailyServiceData, setDailyServiceData] = useState();
  const [serviceData, setServiceData] = useState();
  const [nakshatra, setNakshatra] = useState();
  const cartArr = useSelector((state) => state.cartArr);
  const isLoggedIn = localStorage.getItem("token");
  const devoteeData = JSON.parse(localStorage.getItem("devoteeData"));
  const isStyleOne = templeJson["Services"]?.style === 1;
  const servicestyle = {
    head: isStyleOne ? "page-header py-4 service-head-dt" : "page-header py-4 service-head-svt"
  }
  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Function to increment quantity
  const incrementQuantity = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  // Function to decrement quantity, ensuring it doesn't go below 1
  const decrementQuantity = () => {
    setQuantity((prevQuantity) => (prevQuantity > 1 ? prevQuantity - 1 : 1));
  };

  const handleChildrenRemove = (index) => {
    remove(index);
  };

  const navigate = useNavigate();

  const {
    watch,
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    reset({
      first_name: devoteeData?.first_name,
      last_name: devoteeData?.last_name,
      "persons.0.gotram": devoteeData?.gotram,
      "persons.0.nakshatram": devoteeData?.nakshatram,
    });
  }, []);

  // reset the person 1 values

  const { fields, append, remove } = useFieldArray({
    control,
    name: "persons",
  });

  const getNakshatra = async () => {
    const response = await getApi(apiEndPoints.nakshatram);
    if (response && response.status === 200) {
      setNakshatra(response?.data?.data);
    }
  };
  useEffect(() => {
    getNakshatra();
  }, []);

  useEffect(() => {
    nakshatra?.length > 0 && setValue("nakshatram", payload.nakshatram_id);
  }, [nakshatra]);

  const onSubmit = async (data) => {
    data.quantity = quantity;
    data.selectedDate = new Date(watch("starting_date"));
    data.title = serviceData?.title;
    data.type = serviceData?.type;
    data.amount = serviceData?.amount;

    if (isLoggedIn) {
      const existingCartItem = cartArr.find(
        (cartItem) => cartItem._id === data.pooja_id
      );
      logEvent("Recurring Service Request", "Request Service", data.title);

      if (existingCartItem) {
        const updatedItem = {
          ...existingCartItem,
          quantity: quantity || 1,
          selectedDate: data.starting_date,
        };
        dispatch(updateCart(updatedItem));
        navigate("/checkout");
      } else {
        const newItem = {
          ...data,
          quantity: quantity || 1,
          selectedDate: data.starting_date,
        };
        dispatch(updateCart(newItem));
        navigate("/checkout");
      }
    } else {
      toast.error("Please Login to Order Pooja.");
    }
  };

  const handleClickAddRow = () => {
    append(defaultValues);
    setVisibleRows(visibleRows + 1);
  };

  useEffect(() => {
    const startingDate = watch("starting_date");

    let newEvents = [];

    if (serviceData?.category_slug === "daily") {
      let startDate = new Date(startingDate);

      for (let i = 0; i < quantity; i++) {
        const currentDate = new Date(startDate);
        currentDate.setDate(currentDate.getDate() + i);

        newEvents.push({
          start: currentDate,
          end: currentDate,
          title: serviceData?.title || "Untitled Event",
        });
      }
    } else if (serviceData?.category_slug === "weekly" && quantity > 0) {
      let startDate = new Date(startingDate);

      for (let i = 0; i < quantity; i++) {
        const weeklyDate = new Date(startDate);

        weeklyDate.setDate(startDate.getDate() + i * 7);

        newEvents.push({
          start: weeklyDate,
          end: weeklyDate,
          title: serviceData?.title || "Untitled Event",
        });
      }
    } else if (serviceData?.category_slug === "monthly" && quantity > 0) {
      let startDate = new Date(startingDate);

      for (let i = 0; i < quantity; i++) {
        const currentMonth = new Date(startDate);
        currentMonth.setMonth(currentMonth.getMonth() + i);

        newEvents.push({
          start: currentMonth,
          end: currentMonth,
          title: serviceData?.title || "Untitled Event",
        });
      }
    }
    setEvents(newEvents);
  }, [quantity, watch("starting_date"), serviceData?.category_slug]);

  // functions for services

  const dailyServicePayload = {
    slug: "daily",
  };
  const weeklyServicePayload = {
    slug: "weekly",
  };
  const monthlyServicePayload = {
    slug: "monthly",
  };

  const getMonthlyServicesData = async () => {
    try {
      const response = await postApi(
        apiEndPoints.getAllServicesAtTempleByServicesSlug,
        monthlyServicePayload
      );
      setMonthlyServiceData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getWeeklyServicesData = async () => {
    try {
      const response = await postApi(
        apiEndPoints.getAllServicesAtTempleByServicesSlug,
        weeklyServicePayload
      );
      setWeeklyServiceData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getReligiousServices = async () => {
    const response = await postApi(
      apiEndPoints.getAllServicesAtTempleByServicesSlug,
      dailyServicePayload
    );

    if (response && response.status === 200) {
      setDailyServiceData(response?.data?.data);
    }
  };

  useEffect(() => {
    getMonthlyServicesData();
    getWeeklyServicesData();
    getReligiousServices();
  }, []);

  // function for getting selected service details
  const getServiceData = async () => {
    try {
      const response = await getApi(
        `${apiEndPoints.getSpecificService}/${watch("pooja_id")}`
      );
      setServiceData(response?.data?.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    watch("pooja_id") && getServiceData();
  }, [watch("pooja_id")]);

  return (
    <>
      <Container maxWidth={false} className={servicestyle?.head}>
        <h1 className="text-center service-head display-6 breadcrumb-h1">
          Recurring Puja Booking
        </h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/">Services</Link>
          </li>
          <li className="breadcrumb-item active">Recurring Puja Booking</li>
        </ol>
      </Container>
      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            {templeJson["templeName"]}
          </h6>
          <h1 className="mb-1">
            <span className="text-secundary">Recurring Puja Booking</span>
          </h1>
        </Grid>

        <Grid container>
           <Grid lg={9} md={9} sm={12} xs={12}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                    <TextField
                      {...register(`first_name`)}
                      margin="normal"
                      fullWidth
                      label="First Name 1*"
                      error={errors?.first_name?.message}
                      helperText={errors?.first_name?.message}
                    />
                  </Grid>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                      <TextField
                        {...register(`last_name`)}
                        margin="normal"
                        fullWidth
                        label="Last Name*"
                        error={errors?.last_name?.message}
                        helperText={errors?.last_name?.message}
                      />
                  </Grid>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                      <TextField
                        {...register("persons.0.gotram")}
                        margin="normal"
                        fullWidth
                        label="Gotram"
                        error={errors?.gotram?.message}
                        helperText={errors?.gotram?.message}
                      />
                  </Grid>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                    <Controller
                      control={control}
                      name="persons.0.nakshatram"
                      render={({ field, fieldState }) => {
                        return (
                          <FormControl
                            key={field.value}
                            fullWidth
                            error={fieldState?.error?.message}
                            className="dropdown-margin-top"
                          >
                            <InputLabel id="demo-simple-select-label">
                              Nakshatram
                            </InputLabel>
                            <Select
                              {...field}
                              labelId="demo-simple-select-label"
                              label="Nakshatram"
                              defaultValue={field.value}
                            >
                              {nakshatra?.map((item) => (
                                <MenuItem
                                  key={item._id}
                                  value={item._id}
                                >
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        );
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                      <TextField
                        {...register(`persons.1.first_name`)}
                        margin="normal"
                        fullWidth
                        label="First Name 2"
                      />
                  </Grid>

                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                      <TextField
                        {...register(`persons.1.last_name`)}
                        margin="normal"
                        fullWidth
                        label="Last Name "
                      />
                  </Grid>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                      <TextField
                        {...register("persons.1.gotram")}
                        margin="normal"
                        fullWidth
                        label="Gotram"
                        error={errors?.gotram?.message}
                        helperText={errors?.gotram?.message}
                      />
                  </Grid>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                      <FormControl
                        fullWidth
                        className="dropdown-margin-top"
                      >
                        <InputLabel id="demo-simple-select-label">
                          Nakshatram
                        </InputLabel>
                        <Select
                          {...register(`persons.1.nakshatram`)}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Nakshatram"
                        >
                          {nakshatra?.map((item) => (
                            <MenuItem key={item._id} value={item._id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                        <TextField
                          {...register(`persons.2.first_name`)}
                          margin="normal"
                          fullWidth
                          label="First Name 2"
                        />
                  </Grid>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                      <TextField
                        {...register(`persons.2.last_name`)}
                        margin="normal"
                        fullWidth
                        label="Last Name "
                      />
                  </Grid>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                      <TextField
                        {...register("persons.2.gotram")}
                        margin="normal"
                        fullWidth
                        label="Gotram"
                        error={errors?.gotram?.message}
                        helperText={errors?.gotram?.message}
                      />
                  </Grid>
                  <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                      <FormControl
                        fullWidth
                        className="dropdown-margin-top"
                      >
                        <InputLabel id="demo-simple-select-label">
                          Nakshatram
                        </InputLabel>
                        <Select
                          {...register(`persons.2.nakshatram`)}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Nakshatram"
                        >
                          {nakshatra?.map((item) => (
                            <MenuItem key={item._id} value={item._id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                  </Grid>
                </Grid>
                <AccordionDetails>
                  {fields.slice(3).map((item, index) => (
                    <Grid key={item.id} container>
                      <ConsentDialog
                        index={index}
                        onAgree={handleChildrenRemove}
                      />
                      <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                        <TextField
                          {...register(`persons[${index}].first_name`)}
                          margin="normal"
                          fullWidth
                          label={`First Name ${index + 4}`}
                        />
                      </Grid>

                      <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                        <TextField
                          {...register(`persons[${index}].last_name`)}
                          margin="normal"
                          fullWidth
                          label="Last Name "
                        />
                      </Grid>
                      <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                        <TextField
                          {...register("gotram")}
                          margin="normal"
                          fullWidth
                          label="Gotram"
                          error={errors?.gotram?.message}
                          helperText={errors?.gotram?.message}
                        />
                      </Grid>
                      <Grid item p={1} lg={3} md={3} sm={12} xs={12}>
                        <FormControl
                          fullWidth
                          className="dropdown-margin-top"
                        >
                          <InputLabel id="demo-simple-select-label">
                            Nakshatram
                          </InputLabel>
                          <Select
                            {...register(
                              `persons[${index}].nakshatram`
                            )}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Nakshatram"
                          >
                            {nakshatra?.map((item) => (
                              <MenuItem key={item._id} value={item._id}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  ))}
                  <Box display="flex" justifyContent="end">
                    <IconButton
                      type="button"
                      color="success"
                      onClick={handleClickAddRow}
                    >
                      <AddCircle />
                    </IconButton>
                  </Box>
                </AccordionDetails>
                <Grid container alignItems={'center'} px={3} py={1}>
                  <Grid lg={3} >
                    <span>Name of the Puja : </span>
                  </Grid>
                  <Grid lg={4} >
                    <FormControl sx={{ m: 1, minWidth: 200 }}>
                      <InputLabel htmlFor="grouped-native-select">
                        Select Service
                      </InputLabel>
                      <Select
                        native
                        defaultValue=""
                        id="grouped-native-select"
                        label="Select Service"
                        {...register(`pooja_id`)}
                        error={errors?.service?.message}
                      >
                        <option aria-label="None" value="" />
                        <optgroup label="Select Daily Puja">
                          {dailyServiceData &&
                            dailyServiceData.map((item, index) => (
                              <option value={item._id}>
                                {item.title}
                              </option>
                            ))}
                        </optgroup>
                        <optgroup label="Select Weekly Puja">
                          {weeklyServiceData &&
                            weeklyServiceData.map((item, index) => (
                              <option value={item._id}>
                                {item.title}
                              </option>
                            ))}
                        </optgroup>
                        <optgroup label="Select Monthly Puja">
                          {monthlyServiceData &&
                            monthlyServiceData.map((item, index) => (
                              <option value={item._id}>
                                {item.title}
                              </option>
                            ))}
                        </optgroup>
                      </Select>
                      {errors?.pooja_id && (
                        <FormHelperText error={true}>
                          {errors.pooja_id.message}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container alignItems={'center'} px={3} py={1}>
                    <Grid lg={3} >Quantity :</Grid>
                    <Grid lg={4} >
                      <IconButton
                        color="error"
                        aria-label="decrease quantity"
                        onClick={decrementQuantity}
                      >
                        <RemoveCircle />
                      </IconButton>
                      {quantity}
                      <IconButton
                        color="success"
                        aria-label="increase quantity"
                        onClick={incrementQuantity}
                      >
                        <AddCircle />
                      </IconButton>
                    </Grid>
                </Grid>
                <Grid container alignItems={'center'} px={3} py={1}>
                    <Grid lg={3}>
                      <div>Starting Date : </div>
                    </Grid>
                    <Grid lg={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <Controller
                            control={control}
                            name={`starting_date`}
                            render={({ field }) => {
                              return (
                                <DatePicker
                                  {...field}
                                  label="Select a date"
                                  shouldDisableDate={
                                    serviceData &&
                                    serviceData?.category_slug ===
                                      "weekly"
                                      ? (date) => {
                                          const currentDate =
                                            new Date();
                                          if (date < currentDate) {
                                            return true;
                                          }
                                          return (
                                            new Date(date).getDay() !==
                                            Number(serviceData?.days)
                                          );
                                        }
                                      : serviceData?.category_slug ===
                                        "monthly"
                                      ? (date) => {
                                          const currentDate =
                                            new Date();
                                          if (date < currentDate) {
                                            return true;
                                          }

                                          const year = new Date(
                                            date
                                          ).getFullYear();
                                          const month = new Date(
                                            date
                                          ).getMonth();

                                          const firstDayOfMonth =
                                            new Date(year, month, 1);

                                          const firstDayOfWeek =
                                            firstDayOfMonth.getDay();

                                          const offset =
                                            (serviceData?.days -
                                              firstDayOfWeek +
                                              7) %
                                            7;

                                          const firstSelectableDate =
                                            new Date(
                                              year,
                                              month,
                                              1 +
                                                offset +
                                                (Number(
                                                  serviceData?.positions
                                                ) -
                                                  1) *
                                                  7
                                            );

                                          return (
                                            new Date(date).getDate() !==
                                              firstSelectableDate.getDate() ||
                                            new Date(
                                              date
                                            ).getMonth() !==
                                              firstSelectableDate.getMonth() ||
                                            new Date(
                                              date
                                            ).getFullYear() !==
                                              firstSelectableDate.getFullYear()
                                          );
                                        }
                                      : serviceData?.category_slug ===
                                        "daily"
                                      ? (date) => {
                                          const currentDate =
                                            new Date();
                                          currentDate.setHours(
                                            0,
                                            0,
                                            0,
                                            0
                                          );
                                          return date < currentDate;
                                        }
                                      : undefined
                                  }
                                />
                              );
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid>
                    <div className="d-flex gap-5 mt-3 align-items-center"></div>
                </Grid>
                    {/* schedule */}
                <Grid container alignItems={'center'} px={3} py={1}>
                    <Grid lg={3}>
                      <div>Schedule : </div>
                    </Grid>

                    <Grid lg={4}>
                      <Button 
                        variant="contained"
                        color="primary" 
                        onClick={handleClickOpen}
                      >
                        View Schedule
                      </Button>
                      <Dialog
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                          style: { maxWidth: "90%", width: "90%" },
                        }}
                      >
                        <DialogTitle>Schedule</DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            Quantity: {quantity}
                          </DialogContentText>
                          <div style={{ height: 500, width: "100%" }}>
                            <Calendar
                              localizer={localizer}
                              events={events}
                              startAccessor="start"
                              endAccessor="end"
                              defaultDate={new Date()}
                              views={["month"]}
                            />
                          </div>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleClose} color="primary">
                            Close
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Grid>
                </Grid>
                    {/* occasion */}
                <Grid container alignItems={'center'} px={3} py={1}>
                    <Grid lg={3}>
                      <span>Occasion :</span>
                    </Grid>

                    <Grid lg={4}>
                      <FormControl
                        fullWidth
                        className="dropdown-margin-top"
                      >
                        <InputLabel id="demo-simple-select-label">
                          Select Ocassion
                        </InputLabel>
                        <Select
                          {...register(`ocassion`)}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Select Service"
                          error={errors?.ocassion?.message}
                        >
                          <MenuItem value="birthday">Birthday</MenuItem>
                          <MenuItem value="marriage">Marriage</MenuItem>
                          <MenuItem value="wedding_anniversary">
                            Wedding Anniversary
                          </MenuItem>
                          <MenuItem value="others">Others</MenuItem>
                        </Select>
                        {errors?.ocassion && (
                          <FormHelperText error={true}>
                            {errors.ocassion.message}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  {watch("ocassion") === "others" ? (
                    <Grid container>
                      <Grid lg={3}></Grid>
                      <Grid lg={4}>
                        <TextField
                          {...register(`custom_ocassion`)}
                          margin="normal"
                          fullWidth
                          label="Enter Ocassion"
                        />
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
                    {/* price */}
                <Grid container alignItems={'center'} px={3} py={1}>
                    <Grid lg={3}>
                      <span>Price :</span>
                    </Grid>
                    <Grid lg={4}>
                      $ {serviceData?.amount * quantity || 0}
                    </Grid>
                </Grid>
                <Button
                  // className="text-white mt-3 py-3"
                  variant="contained"
                  color="primary"
                  type="submit"
                >
                  Proceed to Pay
                </Button>
              </form>
           </Grid>
           <Grid lg={3} md={3} sm={12} xs={12}>
              <PoojaBasket />
           </Grid>
        </Grid>
        {/* <div className="row">
          <div className="row">
            <div className="col-lg-9 col-md-8">
              <div className="row">
                <>
                  <div className="container">
                    <Box
                      sx={{
                        "& .MuiTextField-root": {
                          minWidth: "100% !important",
                        },
                        "& .dropdown-margin-top": {
                          marginTop: "15px !important",
                        },
                        "& .accordion-background": {
                          boxShadow: "none !important",
                        },
                        "& .accordion-background::before": {
                          backgroundColor: "transparent !important",
                        },
                      }}
                    >
                      <form onSubmit={handleSubmit(onSubmit)}>
                        
                      </form>
                    </Box>
                  </div>
                </>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-12">
            </div>
          </div>
        </div> */}
      </Container>
    </>
  );
}

export default RecurringServices;
